import { api } from './client';
import { endpoints } from './endpoints';

/** Drop empty values so the query string stays readable and cacheable. */
function toQuery(params) {
  const query = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value) && value.length === 0) return;
    if (value === false) return;
    query[key] = value;
  });
  return query;
}

export function searchInternships(params) {
  return api.getPaginated(endpoints.internships.root, {
    params: toQuery(params),
  });
}

export function getInternship(identifier) {
  return api.get(endpoints.internships.byId(identifier));
}

/** Sidebar counts for the given search filters (the same ones as the list). */
export function getFacets(params = {}) {
  return api.get(endpoints.internships.facets, { params: toQuery(params) });
}

export function listSaved(params = {}) {
  return api.getPaginated(endpoints.internships.saved, { params });
}

export function saveInternship(id, note) {
  return api.post(endpoints.internships.save(id), {
    note: note ?? null,
  });
}

export function unsaveInternship(id) {
  return api.delete(endpoints.internships.save(id));
}
